import Vue from 'vue';
import _debounce from 'lodash/debounce';
import _throttle from 'lodash/throttle'

export const EventBus = new Vue({
    data() {
        return {
            pageLoaded: false,
            numberOfModules: 0,
            imageCount: 0,
            navOpen: false,
            pageContent: '',
            menus: null,
            windowWidth: 0,
            pageScrolled: false,
            pageScrolledUp: false,
            position: 0,
            zekiFilter: '',
            distanceBottom: false,
            bgFooter: '',
            bgScrollUpIcon: '',
            ie: false,
        };
    },
    created() {
        this._onScroll = _throttle(this.onScroll, 300);
        window.addEventListener('scroll', this._onScroll);
        this._onScroll();

        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        resetImageCount() {
            this.imageCount = 0;
        },
        addImage() {
            this.imageCount++;

            if (!this._imageLoadedTimeout) {
                this._imageLoadedTimeout = _debounce(this.allImagesLoaded, 5000);
            }
            this._imageLoadedTimeout();
        },
        imageLoaded() {
            this.imageCount = Math.max(this.imageCount - 1, 0);

            if (this.imageCount === 0) {
                this.allImagesLoaded();
            }
        },
        allImagesLoaded() {
            this.$emit('images-loaded');
        },
        setPageLoaded(loaded) {
            console.log('loaded', loaded);
            this.pageLoaded = loaded
        },
        setPageContent(pageContent) {
            this.pageContent = pageContent;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        onScroll() {

            const scrollPosition = window.pageYOffset;
            const windowSize     = window.innerHeight;
            const bodyHeight     = document.body.offsetHeight;

            if (this.distanceBottom === false) this.distanceBottom = 500;
            else this.distanceBottom = Math.max(bodyHeight - (scrollPosition + windowSize), 0);

            this.position = window.pageYOffset;
        },
    },
    watch: {
        position: {
            deep: true,
            immediate: true,
            handler(val, oldVal) {
                this.pageScrolledUp = oldVal > val;
            }
        },
    }
});
